import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext';
import { getSSRRenderInputs } from '@confluence/ssr-utilities/entry-points/ssrRenderInputs';

import type { TapTraitAttribute } from './formatTapTraits';
import { formatTapTraits } from './formatTapTraits';

export type SiteUserTraits = {
	attributes: TapTraitAttribute[] | null;
};

export const preloadSiteUserTraits = async (): Promise<void> => {
	if (window.__SSR_SITE_USER_TRAITS__) {
		return;
	}

	const { accessStatus, cloudId, userId } = getPreloaderFnContext();

	if (accessStatus !== 'LICENSED_USE_ACCESS' && accessStatus !== 'LICENSED_ADMIN_ACCESS') {
		return;
	}

	if (!cloudId || !userId) {
		return;
	}

	const { tapContext } = getSSRRenderInputs();
	const attributes = formatTapTraits(tapContext?.siteUser);

	if (!attributes) {
		return;
	}

	window.__SSR_SITE_USER_TRAITS__ = { attributes };
};
